import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { JitsiMeeting } from "@jitsi/react-sdk";
import axios from "axios";


const MeetingPage = () => {
    const { roomName } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [allowed, setAllowed] = useState(false);

    const APP_ID = process.env.REACT_APP_JAAS_APP_ID;
      useEffect(() => {
        console.log("Meeting Mounted");
    
        return () => {
            console.log("Meeting Unmounted");
        };
    }, []);

    useEffect(() => {
        const verifyMeeting = async () => {
            try {
                const applicationId = roomName.replace("audition-", "");
                // const token = localStorage.getItem("authToken");
                const token =
    localStorage.getItem("authToken") ||
    localStorage.getItem("adminToken");

                if (!token) {
                    alert("Please login first");
                    navigate("/login");
                    return;
                }

                // API call to verify if meeting is valid
                await axios.get(
                    `${process.env.REACT_APP_API_URL}/meetings/join/${applicationId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                setAllowed(true);
            } catch (error) {
                alert(error?.response?.data?.message || "Meeting link expired");
                navigate("/dashboard/meetings");
            }
            setLoading(false);
        };

        verifyMeeting();
    }, [roomName, navigate]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
                Loading Meeting Room...
            </div>
        );
    }

    if (!allowed) return null;

    return (
        <div style={{ 
            height: "calc(100vh - 150px)", // Footer aur Header ki jagah chhod kar
            width: "100%", 
            backgroundColor: "#000",
            borderRadius: "8px",
            overflow: "hidden"
        }}>
            <JitsiMeeting
                domain="8x8.vc"
                roomName={`${APP_ID}/${roomName}`}
                configOverwrite={{
                    prejoinPageEnabled: false,
                    startWithAudioMuted: false,
                    startWithVideoMuted: false,
                    disableShortcuts: true, 
                }}
                interfaceConfigOverwrite={{
                    // Video Mute button nikaal diya gaya hai
                    TOOLBAR_BUTTONS: [
                        'microphone', 'desktop', 'fullscreen',
                        'fodeviceselection', 'hangup', 'chat', 'settings',
                        'raisehand', 'videoquality', 'tileview', 'security'
                    ],
                }}
                onApiReady={(externalApi) => {
                    // Agar koi shortcut se video band kare toh 1 sec mein wapis on ho jaye
                    externalApi.addListener('videoMuteStatusChanged', (data) => {
                        if (data.muted) {
                            setTimeout(() => {
                                externalApi.executeCommand('toggleVideo');
                            }, 1000);
                        }
                    });

                    // Jab user meeting leave kare toh wapis list par jaye
                    externalApi.addListener('videoConferenceLeft', () => {
                        navigate("/dashboard/meetings");
                    });
                }}
                getIFrameRef={(iframe) => {
                    iframe.style.height = "100%";
                    iframe.style.width = "100%";
                }}
            />
        </div>
    );
};

export default MeetingPage;